export default "__VITE_ASSET__31532724__"